import { WeekDays } from '@/entities/farm'
import { useMemo } from 'react'

const weekDays = [
  { label: 'Пн', value: WeekDays.Mon },
  { label: 'Вт', value: WeekDays.Tue },
  { label: 'Ср', value: WeekDays.Wed },
  { label: 'Чт', value: WeekDays.Thu },
  { label: 'Пт', value: WeekDays.Fri },
  { label: 'Сб', value: WeekDays.Sat },
  { label: 'Вс', value: WeekDays.Sun },
]

export const useWeekdayLabel = (value: number) => {
  return useMemo(() => {
    const selectedDays = weekDays.filter((day) => (value & day.value) !== 0)

    if (selectedDays.length === 0) return 'Не выбрано'

    if (selectedDays.length === 7) return 'Все дни'

    if (selectedDays.length === 1) return selectedDays[0].label

    // Проверка на последовательность
    const firstIndex = weekDays.findIndex((d) => d.value === selectedDays[0]?.value)

    const isSequential = selectedDays.every((day, idx) => {
      const dayIndex = weekDays.findIndex((d) => d.value === day.value)
      return dayIndex === firstIndex + idx
    })

    if (isSequential) {
      return `${selectedDays[0].label} - ${selectedDays[selectedDays.length - 1].label}`
    }

    // Если выбор не подряд — просто через запятую
    return selectedDays.map((d) => d.label).join(', ')
  }, [value])
}
